import axios from "axios";
import instance,{BASE_URL} from "../../services/api";
import toast from "react-hot-toast";
import AuthViewController from "./AuthViewController";

const EmployeeProfileVeiwController = () => {
   const {  getUserDetails} = AuthViewController();
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};

  const getEmployeeProfile = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}employee-profile/`
      );
      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_EMPLOYEE_PROFILE_DETAILS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_PROFILE_DETAILS_FAILURE",
        payload: { error: error },
      });
      // toast.error(message); 
    }
  };

  const addEmployeeProfile = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}employee-profile/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_EMPLOYEE_PROFILE_DETAILS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
      toast.success("Employee added sucessfully");
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_EMPLOYEE_PROFILE_DETAILS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const getEmployees = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}employees/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_EMPLOYEES_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEES_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const addEmployee = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}employees/`,
        reqData
      );
      const data = response.data;
      // const jsonString = JSON.stringify(response.data);
      // const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_EMPLOYEE_SUCCESS", payload: data });
      dispatch(getEmployees());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Employee added successfully");
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const errorMsg =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to add employee";

      toast.error(errorMsg);
      dispatch({
        type: "ADD_EMPLOYEE_FAILURE",
        payload: { error: error },
      });
      return null;
    }
  };

  const updateEmployee = (employeeId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}employees/${employeeId}/`,
        reqData
      );
      const data = response.data;
      // const jsonString = JSON.stringify(response.data);
      // const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_EMPLOYEE_SUCCESS", payload: data });
      dispatch(getEmployees());
      dispatch(getUserDetails());

      dispatch({ type: "LOADING", payload: false });
      toast.success("Employee data updated successfully");
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "UPDATE_EMPLOYEE_FAILURE",
        payload: { error: error },
      });
    }
  };

  const deleteEmployee = (employeeId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}employees/${employeeId}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_EMPLOYEE_SUCCESS", payload: data });
      dispatch(getEmployees());
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_EMPLOYEE_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const addCombinedEmployeeData = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}employee-combined/`,
        reqData
      );
      const data = response.data;
      // const jsonString = JSON.stringify(response.data);
      // const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_COMBINED_EMPLOYEE_DATA_SUCCESS", payload: data });
      dispatch(getEmployees());
      dispatch({ type: "LOADING", payload: false });
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_COMBINED_EMPLOYEE_DATA_FAILURE",
        payload: { error: error },
      });
      return null;
      toast.error(message);
    }
  };

  const addBulkEmployeeData = (file) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const formData = new FormData();
      formData.append("file", file);

      const token = localStorage.getItem("access_token");
      console.log();
      
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };
      const response = await axios.post(
        `${BASE_URL}employees/bulk-upload/`,
        formData,
        config
      );

      dispatch({
        type: "ADD_BULK_EMPLOYEE_DATA_SUCCESS",
        payload: response.data,
      });
      dispatch(getEmployees());
      dispatch({ type: "LOADING", payload: false });
      return response.data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_BULK_EMPLOYEE_DATA_FAILURE",
        payload: { error: error },
      });
      return null;
      toast.error(message);
    }
  };

  //   const updateEmployeeProfile = (reqData) => async (dispatch) => {
  //     dispatch({ type: "LOADING", payload: true });
  //     try {
  //       const response = await instance.put(
  //         "http://127.0.0.1:8000/api/attendance/",
  //         reqData
  //       );

  //       const jsonString = JSON.stringify(response.data);
  //       const data = JSON.parse(jsonString);
  //       dispatch({ type: "UPDATE_ATTENDANCE_SUCCESS", payload: data });
  //       dispatch({ type: "LOADING", payload: false });
  //     } catch (error) {
  //       dispatch({ type: "LOADING", payload: false });
  //       dispatch({
  //         type: "UPDATE_ATTENDANCE_FAILURE",
  //         payload: { error: error }
  //       });
  //     }
  //   };

  return {
    getEmployeeProfile,
    addEmployeeProfile,
    // updateEmployeeProfile,
    getEmployees,
    addEmployee,
    updateEmployee,
    deleteEmployee,
    addCombinedEmployeeData,
    addBulkEmployeeData,
  };
};

export default EmployeeProfileVeiwController;
